<template lang='pug'>
  v-flex(:class='divMainClass')
    u-field-btn-print(v-model='noPrint', :colon='false', @change='onChangeNoPrint')
    img(:src="imgUrl" style="width: 100%;")
</template>

<script>
import UFieldBtnPrint from './FieldBtnPrint'

const getImageURL = 'https://app.ultrahealth.care/functions/healthcareImage?id='
export default {
  name: 'field-image',

  components: {
    UFieldBtnPrint
  },

  props: {
    id: {
      type: String
    },
    size: {
      type: String,
      default: 'xs4'
    }
  },

  computed: {
    imgUrl () {
      return getImageURL + this.id + '&width=300'
    },
    divMainClass () {
      const componentStyle = this.size
      let classe = {
        'no-print not-print': this.noPrint
      }
      classe[componentStyle] = true

      return classe
    }
  },

  data () {
    return {
      noPrint: true
    }
  },

  mounted () {
    setTimeout(() => {
      this.refreshNoPrint()
    }, 500)
  },

  methods: {
    refreshNoPrint () {
      let printItems = localStorage.getItem('print-items')
      if (!printItems) return
      else printItems = JSON.parse(printItems)
      this.noPrint = printItems[this.id]
    },
    onChangeNoPrint () {
      let printItems = localStorage.getItem('print-items')
      if (!printItems) printItems = {}
      else printItems = JSON.parse(printItems)
      printItems[this.id] = this.noPrint
      localStorage.setItem('print-items', JSON.stringify(printItems))
    }
  }
}
</script>

<style lang='stylus' scoped>
  .not-print
    opacity 0.3
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/summary/components/FieldImage.vue